import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=3544b81a&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=js&"
export * from "./Subscribe.vue?vue&type=script&lang=js&"
import style0 from "./Subscribe.vue?vue&type=style&index=0&id=3544b81a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544b81a",
  null
  
)

export default component.exports